export default __webpack_public_path__ + "static/3beam_logo-ae630d7d19d796fb35b09894d34eaf9f.svg";